import { LiveResponseWrapper } from "@/components/live-response/live-response-wrapper";

const LiveMonitor = () => {
  return (
    <div className="h-full flex flex-col bg-background p-6 text-text-500">
      <div className="flex-1">
        <LiveResponseWrapper />
      </div>
    </div>
  );
};

export default LiveMonitor;
